import TableColumnMoveLeftIcon from '@atlaskit/icon/core/table-column-move-left';
import TableColumnMoveRightIcon from '@atlaskit/icon/core/table-column-move-right';
import { SHORTCUTS } from '@databases/keyboard-shortcuts';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { type Trigger, type Action, ActionPopup } from '../ActionPopup.tsx';
import { messages } from '../messages.ts';

type MoveFieldsTypes = {
  handleMoveFieldsLeft: () => void;
  handleMoveFieldsRight: () => void;
  canMoveLeft: boolean;
  canMoveRight: boolean;
};

export const MoveFields = ({
  handleMoveFieldsLeft,
  handleMoveFieldsRight,
  canMoveLeft,
  canMoveRight
}: MoveFieldsTypes) => {
  const { formatMessage } = useIntl();

  const actions: Action[] = [
    {
      type: 'move-left',
      message: formatMessage(messages['action-bar.field-move-left-action']),
      icon: (
        <TableColumnMoveLeftIcon
          label={formatMessage(messages['action-bar.field-move-left-action'])}
          size="medium"
        />
      ),
      onClick: handleMoveFieldsLeft,
      shouldRender: canMoveLeft,
      shortcut: SHORTCUTS.MOVE_FIELDS_LEFT
    },
    {
      type: 'move-right',
      message: formatMessage(messages['action-bar.field-move-right-action']),
      icon: (
        <TableColumnMoveRightIcon
          label={formatMessage(messages['action-bar.field-move-right-action'])}
          size="medium"
        />
      ),
      onClick: handleMoveFieldsRight,
      shouldRender: canMoveRight,
      shortcut: SHORTCUTS.MOVE_FIELDS_RIGHT
    }
  ];

  const trigger: Trigger = {
    type: 'move',
    message: formatMessage(messages['action-bar.field-move-button']),
    icon: (
      <TableColumnMoveRightIcon
        label={formatMessage(messages['action-bar.field-move-button'])}
        size="medium"
      />
    ),
    selectionMode: 'field'
  };

  return <ActionPopup actions={actions} trigger={trigger} />;
};
